export enum ClaimPartyInvolved {
  Employee = 'Employee',
  Subcontractor = 'Subcontractor',
  Other = 'Other',
}

export enum ClaimStatus {
  Active = 'active',
  Closed = 'closed',
  OnNotice = 'on notice',
}

export type ClaimContactForm = {
  id?: string;
  name: string;
  phone?: string;
  email?: string;
  details?: string;
};

export type LogsForm = {
  id?: string;
  date: Date;
  description: string;
  attachment?: File;
  removeAttachment?: boolean;
  prevAttachment?: string;
};

export type ClaimForm = {
  policyID: string;
  employeeID?: string;
  subcontractorID?: string;
  other?: string;
  type?: string;
  number: string;
  contacts?: ClaimContactForm[];
  accidentDate: Date;
  accidentDescription: string;
  status: ClaimStatus;
  logs?: LogsForm[];
  attachment?: File;
  removeAttachment?: boolean;
  relation: ClaimPartyInvolved;
};

export type NewClaimArgs = Omit<
  ClaimForm,
  'logs' | 'status' | 'contacts' | 'removeAttachment' | 'relation'
> & {
  contacts?: Omit<ClaimContactForm, 'id'>[];
};

export type UpdateClaimArgs = Omit<ClaimForm, 'relation' | 'logs'> & {
  logs?: Omit<LogsForm, 'prevAttachment'>[];
};

export type ClaimSummary = {
  id: string;
  policy: { id: string; policy: string };
  employee?: { id: string; name: string };
  subcontractor?: { id: string; name: string };
  other?: string;
  number: string;
  type?: string;
  contacts?: { id: string; name: string }[];
  accidentDate: Date;
  status: ClaimStatus;
  hasAttachment: boolean;
};

export type ClaimContact = {
  id: string;
  name: string;
  phone?: string;
  email?: string;
  details?: string;
};

export type ClaimLog = {
  id: string;
  date: Date;
  description: string;
  attachmentName?: string;
  attachmentPath?: string;
};

export type Claim = Omit<ClaimSummary, 'contacts' | 'hasAttachments'> & {
  contacts?: ClaimContact[];
  logs?: ClaimLog[];
  accidentDescription: string;
  createdAt: Date;
  updatedAt: Date;
  company: { id: string; code: string };
  user: { id: string; firstName: string; lastName: string };
  attachmentName?: string;
  attachmentPath?: string;
};

export type DashboardClaimPolicySummary = {
  id: string;
  policy: string;
  termStart: Date;
  termEnd: Date;
  claims: number;
};

export type ConsolidatedForm = {
  companies: string[];
  periodStart?: Date;
  periodEnd?: Date;
  status?: ClaimStatus | 'all';
};
